// extracted by mini-css-extract-plugin
export default {"root":"hq8Sde","editor":"XHYEgJ","content":"TQSwce","groups":"wFutox"};